import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderDescriptionEditor from '../../OldPortalComponents/HeaderDescriptionEditor'

interface DescriptionQuestionProps {
  tableAnswer: any[][] | null
  onTableChange: (value: any[][]) => void
  onHeaderChange: (value: string[]) => void
}

const DescriptionQuestion: React.FC<DescriptionQuestionProps> = ({
  tableAnswer,
  onTableChange,
  onHeaderChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <h4 className="page-subheading">{t('Answer key')}</h4>
      <HeaderDescriptionEditor
        onHeaderChange={onHeaderChange}
        onTableChange={onTableChange}
        tableValues={tableAnswer}
      />
    </>
  )
}

export default DescriptionQuestion
